export default {"src":"/_next/static/media/map-icon.9d67f36d.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};